import { createRouter, createWebHistory } from 'vue-router'
import { LayoutName } from '@/enums/layout-name'
import { RouterName } from '@/enums/router-name'
import { authGuard } from '@/guards/auth-guard'
import { ssoRedirectGuard } from '@/guards/sso-redirect-guard'
import { useAuthStore } from '@/stores/use-auth-store'

const router = createRouter({
  scrollBehavior: () => {
    return { top: 0, behavior: 'instant' }
  },
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      meta: {
        layout: LayoutName.MAIN_LAYOUT
      },
      beforeEnter: [authGuard],
      children: [
        {
          path: '',
          component: () => import('@/views/home/index.vue'),
          name: RouterName.HOME
        },
        {
          path: 'article/setting',
          component: () => import('@/views/article/article-setting.vue'),
          name: RouterName.ARTICLE_SETTING
        },
        {
          path: 'article/add',
          component: () => import('@/views/article/article-add.vue'),
          name: RouterName.ARTICLE_ADD
        },
        {
          path: 'record/setting',
          component: () => import('@/views/record/record-setting.vue'),
          name: RouterName.RECORD_SETTING
        },
        {
          path: 'record/add',
          component: () => import('@/views/record/record-add.vue'),
          name: RouterName.RECORD_ADD
        },
        {
          path: 'user-permissions/setting',
          component: () =>
            import('@/views/user-permissions/user-permissions-setting.vue'),
          name: RouterName.USER_PERMISSIONS_SETTING
        },
        {
          path: 'user-permissions/add',
          component: () =>
            import('@/views/user-permissions/user-permissions-add.vue'),
          name: RouterName.USER_PERMISSIONS_ADD
        },
        {
          path: 'setting/params',
          component: () => import('@/views/setting/params/params-setting.vue'),
          name: RouterName.PARAMS_SETTING
        },
        {
          path: 'setting/category',
          component: () =>
            import('@/views/setting/category/category-setting.vue'),
          name: RouterName.CATEGORY_SETTING
        },
        {
          path: 'test',
          component: () => import('@/views/test/index.vue'),
          name: RouterName.TEST_PAGE
        }
      ]
    },
    {
      path: '/login',
      component: () => import('@/views/login/index.vue'),
      name: RouterName.LOGIN,
      meta: {}
    },
    /** SSO 轉導頁面 */
    {
      path: '/sso-callback',
      name: RouterName.SSO_CALLBACK,
      component: () => import('@/views/redirect/index.vue'),
      beforeEnter: [ssoRedirectGuard]
    },
    {
      path: '/error',
      name: RouterName.ERROR,
      component: () => import('@/views/error/index.vue'),
      meta: {
        layout: LayoutName.BLANK_LAYOUT
      }
    },
    // 404 - 找不到頁面
    {
      path: '/:pathMatch(.*)*',
      redirect: {
        name: RouterName.ERROR
      }
    }
  ]
})

// 進入路由之前
router.beforeEach(async (to) => {
  const authStore = useAuthStore()

  if (
    to.name !== RouterName.LOGIN &&
    authStore.isTokenEmpty &&
    authStore.isCookiesTokenEmpty() &&
    to.name !== RouterName.ERROR &&
    to.name !== RouterName.SSO_CALLBACK
  ) {
    return { name: RouterName.LOGIN }
  }
})

export default router
